var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{domProps:{"value":_vm.content},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }